module.exports = __webpack_public_path__ + "static/image/company/pc/image_report.ver2_0_2.jpg?8dbd0a25";